// extracted by mini-css-extract-plugin
export default {"outlet_wrapper":"Layouts_outlet_wrapper__mwnTG"};